import logo from "./logo.svg";
import "./App.css";
import QR from "./Component/QR";
function App() {
  return (
    <div className="App">
      <QR />
    </div>
  );
}

export default App;
